import { useEffect, useLayoutEffect } from 'react';

/**
 * useLayoutEffect on the client (runs synchronously before browser paint),
 * useEffect on the server (useLayoutEffect throws a warning during SSR).
 *
 * Use this instead of useEffect when you need to read browser-only values
 * (localStorage, window.location, etc.) and avoid a visible flash on the
 * first render.
 */
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
